export const pad = (x?: number | string) => (x && x <= 9 ? `0${x}` : x);
